export default "__VITE_ASSET__D3BF5GGQ__"